import React from 'react'
import { Row, Col } from 'react-bootstrap'
import {
  i18nTranslate,
  convertToBoolean,
  getLiveEventStatus,
  getTranslatedShippingMethod,
} from 'src/utils'

class OrderShippingView extends React.Component {
  enableLiveEvent = convertToBoolean(getLiveEventStatus())
  renderAddress = () => {
    const shippingInfo = this.props.shippingInfo
    const shippingAddress = shippingInfo?.shippingAddress || {}

    const lastname =
      shippingAddress.lastName || '' != null
        ? shippingAddress.lastName || ''
        : ''

    const fullName = this.enableLiveEvent
      ? i18nTranslate('event.pickupEventAddress', 'PACIFICO Yokohama - Hall D')
      : (shippingAddress?.firstName || '') + ' ' + lastname
    const addressLine = [
      shippingAddress.addressLine1,
      shippingAddress.addressLine2,
    ]
      .filter(Boolean)
      .join(' ')

    const localityData = [
      shippingAddress?.city,
      shippingAddress?.state,
      shippingAddress?.county,
      shippingAddress?.country,
      shippingAddress?.zip,
    ]
      .filter(Boolean)
      .join(', ')
    const email =
      shippingInfo?.shippingEmail ||
      this.props.orderDetails?.customer?.userTracking?.userContact?.email ||
      ''
    return (
      <Row
        className="order-summary-shipping-address-detail"
        noGutters
        data-testid="qa-order-shipping-address-detail">
        <Row
          className="order-summary-sa-value w-100 full-name"
          noGutters
          data-testid="qa-order-shipping-address-name">
          {fullName}
        </Row>
        <Row
          className="order-summary-sa-value w-100 address-line"
          noGutters
          data-testid="qa-order-shipping-address-line">
          {addressLine && `${addressLine},`}
        </Row>
        <Row
          className="order-summary-sa-value w-100 region-address"
          noGutters
          data-testid="qa-order-shipping-address-city-wrapper">
          {localityData && `${localityData},`}
        </Row>
        <Row
          className="order-summary-sa-value w-100 email-address"
          noGutters
          data-testid="qa-order-shipping-address-email">
          {email}
        </Row>
      </Row>
    )
  }

  getShippingMethod = () => {
    const { shippingInfo } = this.props
    let deliveryTerm = shippingInfo?.shippingMethod || ''
    if (deliveryTerm === 'US Mail' || deliveryTerm === 'USMail') {
      deliveryTerm = i18nTranslate('orderCart.USMail', 'US Mail')
    } else if (deliveryTerm === 'Pick UP' || deliveryTerm === 'PickUp') {
      deliveryTerm = i18nTranslate('orderCart.PickUp', 'Pick UP')
    }
    const shippingCode = shippingInfo?.shippingCode
    if (shippingCode && shippingCode.toLowerCase() === 'pickupleon') {
      const shippingMethodNameArr = getTranslatedShippingMethod(
        shippingCode,
        true,
        shippingInfo?.shippingMethod
      )
      return (
        <span>
          {shippingMethodNameArr[0]}
          {shippingMethodNameArr[1] ? ` - ${shippingMethodNameArr[1]}` : ''}
        </span>
      )
    }
    const shippingMethodName =
      getTranslatedShippingMethod(
        shippingInfo?.shippingCode,
        false,
        shippingInfo?.shippingMethod
      ) || deliveryTerm
    return <span> {shippingMethodName} </span>
  }

  getShippingInstructions = () => {
    const { shippingInfo } = this.props
    const deliveryInstruction =
      shippingInfo?.shippingAddress?.deliveryInstruction || ''
    return <span> {deliveryInstruction} </span>
  }

  getPickupLocation = () => {
    const pickupLocationRaw =
      this.props.orderDetails?.otherproperties?.pickupLocation || ''
    if (!pickupLocationRaw) {
      return null
    }
    let pickupLocation = {}
    try {
      pickupLocation =
        typeof pickupLocationRaw === 'string'
          ? JSON.parse(pickupLocationRaw)
          : pickupLocationRaw
    } catch (e) {
      return null
    }
    const pickupName = pickupLocation?.name || ''
    const addressParts = [
      pickupLocation?.street,
      pickupLocation?.city,
      pickupLocation?.postalCode,
    ].filter(Boolean)
    if (!pickupName && addressParts.length === 0) {
      return null
    }
    return (
      <Row
        className="order-summary-sa-value w-100 order-summary-pickup-location-detail"
        noGutters
        data-testid="qa-order-pickup-location">
        {pickupName && (
          <Row noGutters className="w-100">
            {pickupName}
          </Row>
        )}
        {addressParts.length > 0 && (
          <Row noGutters className="w-100">
            {addressParts.join(', ')}
          </Row>
        )}
      </Row>
    )
  }

  render() {
    return (
      <Row noGutters className="pt-3 order-summary-shipping-container">
        <Col
          className={`order-summary-details px-0 pb-3 order-summary-shipping-address`}
          data-testid="qa-order-shipping-address">
          <div>
            <h6
              className="font-weight-bold"
              data-testid="qa-order-shipping-address-title">
              {!this.enableLiveEvent
                ? i18nTranslate(
                    'orderSummary.shippingAddressTitle',
                    'Shipping Address'
                  )
                : i18nTranslate(
                    'orderSummary.pickupAddressTitle',
                    'Pickup Address'
                  )}
            </h6>
            {this.renderAddress()}
          </div>
        </Col>
        {!this.enableLiveEvent && (
          <Col
            className={`order-summary-details px-0 pb-3 order-summary-shipping-method`}
            data-testid="qa-order-shipping-methods">
            <div>
              <h6 className="font-weight-bold">
                {i18nTranslate(
                  'orderSummary.shippingMethodTitle',
                  'Shipping Method'
                )}
              </h6>
              {this.getShippingMethod()}
              {this.getPickupLocation()}
            </div>
          </Col>
        )}
        {this.props?.shippingInfo?.shippingAddress?.deliveryInstruction
          ?.length > 0 && (
          <Col
            className={`order-summary-details px-0 pb-3 order-summary-shipping-instructions`}
            data-testid="qa-order-shipping-instructions">
            <div>
              <h6 className="font-weight-bold">
                {i18nTranslate(
                  'orderSummary.shippingInstructionsTitle',
                  'Shipping Instructions'
                )}
              </h6>
              {this.getShippingInstructions()}
            </div>
          </Col>
        )}
      </Row>
    )
  }
}

export { OrderShippingView }
